// services/empleadoService.ts
import { api } from "./api";
import { EmpleadoResponse } from "../types/empleado";

export const EmpleadoService = {

  getAll: (activo: boolean) => {
    return api.get(`/empleados/${activo ? 1 : 0}`);
  },

  getSinUsuario: () => {
    return api.get("/empleados/sin-usuario/disponibles");
  },

  getSinAgente: (id: number) => {
    if (!Number.isInteger(id) || id < 0) {
      throw new Error("ID debe ser un número positivo");
    }
    return api.get(`/empleados/sin-agente/${id}`);
  },

  getById: (id: number) => {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("ID debe ser un número positivo");
    }
    return api.get(`/empleados/${id}/individual`);
  },
  crear: (data: EmpleadoResponse) => {
    return api.post("/empleados", data);
  },

  actualizar: (id: number, data: EmpleadoResponse) => {
    return api.put(`/empleados/${id}/actualizar`, data);
  },
  desactivar: (id: number) => {
    return api.put(`/empleados/${id}/desactivar`);
  },

  activar: (id: number) => {
    return api.put(`/empleados/${id}/activar`);
  }

};

